import { render, staticRenderFns } from "./Franchise.vue?vue&type=template&id=8815a370&scoped=true&"
var script = {}
import style0 from "./Franchise.vue?vue&type=style&index=0&id=8815a370&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8815a370",
  null
  
)

export default component.exports